import React from 'react';
import { Field, reduxForm } from 'redux-form';

import PermissionsSelector from './PermissionsSelector';

const buildFieldName = (slug, scope) => {
  const [model, field] = slug ? slug.split('.') : [];
  const appPath = `apps.${scope}.${scope}.value`;
  const modelPath = `models.${scope}.${model}.value`;
  const fieldPath = `models.${scope}.${model}.columns.${field}`;

  return field ? fieldPath : model ? modelPath : appPath;
};

const ConnectedPermissionSelector = reduxForm({
  form: 'role',
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
})(PermissionsSelector);

const permissionSelectRenderer = props => ({ rowData }) => {
  if (props.actionsByResource) {
    const newProps = props;

    newProps.actionsByResource.forEach(action => {
      if (action.name === rowData.name) {
        newProps.options = action.list;
      }
    });
  }

  return (
    <Field
      {...props}
      rowData={rowData}
      component={ConnectedPermissionSelector}
      name={buildFieldName(rowData.slug, props.productScope)}
    />
  );
};

export default permissionSelectRenderer;
